export default __webpack_public_path__ + "static/media/pic5.c62c6d34.jpg";